/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { Link, Title } from '@express-labs/raven-ui';
import PropTypes from 'prop-types';

import SearchInput from './subcomponents/SearchInput';
import s from './Search.module.scss';
import { AUTOCOMPLETE_DATASET, MAX_MOBILE_WIDTH } from '../../../../constants';

function Search({
  data,
  visitorId = '',
  getSuggestions,
  isGoogleRetailAutoCompleteEnabled = false,
  suggestions,
  suggestionsLoading,
  width,
}) {
  const deviceWidth = width <= MAX_MOBILE_WIDTH ? 'MOBILE' : 'DESKTOP';
  const [search, setSearch] = useState('');
  const [savedSuggestions, setSavedSuggestions] = useState({});

  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    setSearch(inputValue);

    if (isGoogleRetailAutoCompleteEnabled && inputValue.length >= 2) {
      const retrievedSuggestions = sessionStorage.getItem(inputValue?.toLowerCase());
      if (retrievedSuggestions && retrievedSuggestions !== 'undefined') {
        setSavedSuggestions({
          query: inputValue,
          values: JSON.parse(retrievedSuggestions),
        });
        sessionStorage.setItem('lastSuggestions', retrievedSuggestions);
      } else {
        getSuggestions({
          variables: {
            payload: {
              dataset: AUTOCOMPLETE_DATASET, // empty will use preloaded user-data
              deviceType: deviceWidth,
              query: inputValue,
              visitorId,
            },
          },
        });
      }
    }
  };

  let items = data;
  const isTrendingSearch = (links) => (links?.[0]?.category === 'trending-search');

  if (isGoogleRetailAutoCompleteEnabled) {
    const lastItems = sessionStorage.getItem('lastSuggestions');
    if (
      suggestionsLoading && search.length === 2
      && !isTrendingSearch(lastItems)
      && lastItems
    ) {
      items = JSON.parse(lastItems);
    } else if (suggestionsLoading && lastItems) {
      items = JSON.parse(lastItems);
    } else if (savedSuggestions.query === search && search.length > 1) {
      items = savedSuggestions.values;
    } else if (suggestions && search.length > 1) {
      items = suggestions;
    }
    if (search.length <= 1) {
      sessionStorage.setItem('lastSuggestions', JSON.stringify(data));
    }
  }

  const renderMenuLinks = (links) => links?.map((val) => (
    <Link
      key={val.title}
      href={val.url}
      className={s.searchLink}
    >
      {val.title}
    </Link>
  ));

  return (
    <div className={s.container}>
      <SearchInput
        name="q"
        id="header-search-field"
        placeholder="Search"
        onChange={handleChange}
        value={search}
        className={s.searchInput}
      />
      {(isTrendingSearch(items)) ? (
        <Title tag="h4" className={s.trendingSearch}>Trending Search</Title>
      ) : (
        <Title className={s.nonTrendingSearch} />
      )}
      {renderMenuLinks(items)}
    </div>
  );
}

Search.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(
    { title: PropTypes.string.isRequired, url: PropTypes.string.isRequired },
  )).isRequired,
  getSuggestions: PropTypes.func.isRequired,
  isGoogleRetailAutoCompleteEnabled: PropTypes.bool,
  suggestions: PropTypes.arrayOf(PropTypes.shape(
    { title: PropTypes.string, url: PropTypes.string },
  )),
  suggestionsLoading: PropTypes.bool,
  visitorId: PropTypes.string,
  width: PropTypes.number.isRequired,
};

export default Search;
